import React from 'react';

import { siteServedAdTrackingWrapper } from 'site-modules/shared/components/native-ad/site-served-ad-tracking-wrapper/site-served-ad-tracking-wrapper';

import { BuildPriceSiteServedAdUI } from './buildprice-site-served-ad';

export function BuildPriceSiteServedNarrowAdUI(props) {
  return <BuildPriceSiteServedAdUI {...props} hideJelly showOnlyNarrowView />;
}

BuildPriceSiteServedNarrowAdUI.propTypes = BuildPriceSiteServedAdUI.propTypes;

export const BuildPriceSiteServedNarrowAd = siteServedAdTrackingWrapper(BuildPriceSiteServedNarrowAdUI);
